(function($) {

	$.fn.initMenuClick = function() {

		this.click(function() {

			$('#nav-icon2').toggleClass('open');

			if($("#submenu-mobile").is(".open")){

				$("#submenu-mobile").removeClass("open");
				$(".c-header").removeClass("open");
				$(".c-header-hp").removeClass("open");
				$('.submenu').removeClass('open');
				$('.item').removeClass('open');
				$('.news').removeClass('hide');

			}else {

				$("#submenu-mobile").addClass("open");
				$(".c-header").addClass("open");
				$(".c-header-hp").addClass("open");
				$('.submenu').addClass('open');
				$('.menu-level-1').addClass('open');
				$('.news').addClass('hide');

			}

		});

		return this;

	}


})(jQuery);


(function($) {

	$.fn.initSubmenu = function() {

		this.click(function() {

			var id = $(this).attr("data-id");
			var idLevel = $(this).attr("data-level");
			var idLevelP = idLevel - 1;

			$('#sub-'+id).addClass('open');
			$('.menu-level-'+idLevelP).removeClass('open');
			$('.menu-level-'+idLevel).addClass('open');
			$('.menu-level-'+idLevelP).addClass('close');

		});

		return this;

	}

})(jQuery);

(function($) {

	$.fn.initMenuBack = function() {

		this.click(function() {

			var back = $(this).attr("data-back");
			//$('.menu-level-'+back).addClass('open');
			var actual = $(this).attr("data-actual");
			//alert(""+actual);
			$('.menu-level-'+actual).removeClass('open');
			$('.menu-level-'+actual).removeClass('close');
			$('.menu-level-'+back).addClass('open');
			$('.menu-level-'+back).removeClass('close');
			$('.menu-level-'+actual).find(".sub").removeClass('open');

		});

		return this;

	}

})(jQuery);

(function($) {

	$.fn.initClose = function() {

		this.click(function() {

			$("body").removeClass("overflow");
			

		});

		return this;

	}

})(jQuery);


$(function() {

	$("#menu-button-responsiv").initMenuClick();
	$(".item-menu").initSubmenu();
	$(".menu-back").initMenuBack();
	$(".close").initClose();

});
